/**
 * @generated SignedSource<<8409b2c5cead166ce36e7678adf538e6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DevOpsSecurityVulnerabilityStatus = "CLOSED" | "IGNORED" | "OPEN" | "UNKNOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type main_developmentSummaryVulnerability_Vulnerability$data = ReadonlyArray<{
  readonly status: DevOpsSecurityVulnerabilityStatus | null | undefined;
  readonly url: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"indexOld_developmentSummaryVulnerability_VulnerabilityDropdown" | "vulnerabilityDropdownItem_developmentSummaryVulnerability_VulnerabilityDropdownItemEntryPoint_vulnerabilityDropdownData">;
  readonly " $fragmentType": "main_developmentSummaryVulnerability_Vulnerability";
}>;
export type main_developmentSummaryVulnerability_Vulnerability$key = ReadonlyArray<{
  readonly " $data"?: main_developmentSummaryVulnerability_Vulnerability$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_developmentSummaryVulnerability_Vulnerability">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcvulnerabilitydropdownivllcdevpanelrelayprovider"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "main_developmentSummaryVulnerability_Vulnerability",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcvulnerabilitydropdownivllcdevpanelrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "indexOld_developmentSummaryVulnerability_VulnerabilityDropdown"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcvulnerabilitydropdownivllcdevpanelrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "vulnerabilityDropdownItem_developmentSummaryVulnerability_VulnerabilityDropdownItemEntryPoint_vulnerabilityDropdownData"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "DevOpsSecurityVulnerabilityDetails"
};

(node as any).hash = "7291243e1bab0862356387e7da4633fd";

export default node;
